import { AxisSwitcher, Button, GridBox, H2, H4, P, SpacerWrapper } from '@ahmdigital/ui';
import { FC } from 'react';
import { map } from 'lodash/fp';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 4rem 0;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin: 4rem;
  }
`;

const Title = styled(H2)`
  text-align: center;
  margin-bottom: 2rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin-bottom: 4rem;
  }
`;

const StyledButton = styled(Button)`
  @media (min-width: ${({ theme }) => theme.media.xs}) {
    padding: 1rem 4rem;
  }
`;

export type WhyAhmData = ReadonlyArray<{
  description: string;
  heading: string;
}>;

type WhyAhmProps = Readonly<{
  link: string;
  linkText: string;
  textBlocks: WhyAhmData;
  title: string;
}>;

const WhyAhm: FC<WhyAhmProps> = ({ link, linkText, textBlocks, title }) => (
  <GridBox padding="1rem">
    <Container>
      <Title>{title}</Title>
      <AxisSwitcher limit={3} threshold="60rem" space="2.5rem">
        {map(
          ({ description, heading }) => (
            <SpacerWrapper key={heading}>
              <H4 variant={['center', 'marginTopSpacer10', 'simpleBit']}>{heading}</H4>
              <P variant={['center', 'marginTopSpacer11', 'regular']}>{description}</P>
            </SpacerWrapper>
          ),
          textBlocks,
        )}
      </AxisSwitcher>
      <StyledButton variant={['border', 'marginTopSpacer5', 'white']} to={link}>
        <P looksLike="h6">{linkText}</P>
      </StyledButton>
    </Container>
  </GridBox>
);

export default WhyAhm;
